<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (display) {
  <div
    class="progress-banner"
    [@parentAnimation]
    role="region"
    [attr.aria-label]="'SDE_VIEW_JOBS' | xdaTranslate">
    <div class="progress-container">
      <div class="progress-text" [@childAnimation]>
        <div class="processing-title">
          <span
            [xdaTranslate]="'SDE_JOBS_PROCESSING_FMTSTR'"
            [formatValues]="[currentStatus.processingStates.toString()]"></span>
          <span
            [xdaTranslate]="'SDE_PROCESSING_FMTSTR'"
            [formatValues]="[currentStatus.processingStates.toString()]"></span>
        </div>
        @if (showProcessedStatus()) {
          <div class="processed-status" [@childAnimation]>
            @if (currentStatus.erroredStates) {
              <div class="error">
                <span class="xgl-alert"></span>
                <span
                  [xdaTranslate]="'SDE_ERROR_FMTSTR1'"
                  [formatValues]="
                    currentStatus.erroredStates.toString()
                  "></span>
                <span [textContent]="currentStatus.erroredStates"></span>
              </div>
            }
            @if (currentStatus.waitingStates) {
              <div class="waiting">
                <span class="xgl-alarmclock"></span>
                <span
                  [xdaTranslate]="'SDE_WAITING_FMTSTR'"
                  [formatValues]="
                    currentStatus.waitingStates.toString()
                  "></span>
                <span [textContent]="currentStatus.waitingStates"></span>
              </div>
            }
            @if (currentStatus.completedStates) {
              <div class="complete">
                <span class="xgl-checkmark_circle_break"></span>
                <span
                  [xdaTranslate]="'SDE_COMPLETE_FMTSTR'"
                  [formatValues]="
                    currentStatus.completedStates.toString()
                  "></span>
                <span [textContent]="currentStatus.completedStates"></span>
              </div>
            }
          </div>
        }
      </div>
      <div class="progress-buttons flex-center" [@childAnimation]>
        <button
          class="xrx-btn btn-secondary btn-sm"
          (click)="viewDetails()"
          [xdaTranslate]="'SDE_VIEW_JOBS'"></button>
      </div>
    </div>
  </div>
}
@if (display) {
  <div class="sticky-spacer"></div>
}
